import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Download, Sparkles } from "lucide-react";

export default function Reports() {
  const [catalog, setCatalog] = useState([]);
  const [generated, setGenerated] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/reports/catalog").then(r => setCatalog(r.data)); }, []);

  const generate = async (id) => {
    setLoading(true);
    try {
      const r = await api.post("/reports/generate", { id });
      setGenerated(r.data);
      toast.success("Report generated");
    } finally { setLoading(false); }
  };

  const byCat = catalog.reduce((acc, r) => { (acc[r.category] = acc[r.category] || []).push(r); return acc; }, {});

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <div className="xl:col-span-2 space-y-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Reporting & Analytics</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Report Catalog ({catalog.length})</h1>
        </div>
        {Object.entries(byCat).map(([cat, items]) => (
          <div key={cat} className="bg-zinc-950 border border-zinc-900 rounded-md">
            <div className="px-5 py-3 border-b border-zinc-900 font-display font-medium">{cat}</div>
            <div className="divide-y divide-zinc-900">
              {items.map(r => (
                <div key={r.id} className="flex items-center justify-between px-5 py-3 hover:bg-zinc-900/30">
                  <div>
                    <div className="text-sm">{r.name}</div>
                    <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{r.id}</div>
                  </div>
                  <button onClick={()=>generate(r.id)} disabled={loading} data-testid={`report-generate-${r.id}`} className="inline-flex items-center gap-1 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded px-3 py-1.5"><Sparkles size={12}/> Generate</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div>
        <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5 sticky top-20">
          <div className="font-display font-medium mb-2">Preview</div>
          {!generated && <div className="text-sm text-zinc-500">Generate a report to preview its data here.</div>}
          {generated && (
            <div>
              <div className="text-sm">{generated.report?.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-2">{generated.generated_at?.slice(0,16).replace("T"," ")}</div>
              <pre className="text-[11px] whitespace-pre-wrap text-zinc-300 leading-relaxed max-h-96 overflow-auto bg-zinc-900/40 border border-zinc-900 rounded p-3" data-testid="report-output">{JSON.stringify(generated.data, null, 2)}</pre>
              <div className="flex gap-2 mt-3"><button className="text-xs bg-zinc-900 border border-zinc-800 rounded px-3 py-1.5 inline-flex items-center gap-1"><Download size={12}/> PDF</button><button className="text-xs bg-zinc-900 border border-zinc-800 rounded px-3 py-1.5 inline-flex items-center gap-1"><Download size={12}/> Excel</button></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
